import VideoGenericElement from '$components/GenericElements/VideoGenericElement';
import { GetSharedCandidatesRosterDataOutput } from '$store/modules/candidates';

const SPKVideoModal = ({
  selectedCandidate,
}: {
  selectedCandidate: GetSharedCandidatesRosterDataOutput['candidates'][number];
}) => {
  return (
    <div className="font-mulish bg-white rounded-2xl p-4">
      <div>
        <p>
          by{' '}
          <span className="font-semibold">
            {selectedCandidate?.User.FirstName}
          </span>
        </p>
        <p className="font-semibold text-2xl">
          {selectedCandidate?.AdditionalVideos?.[0]?.Name}
        </p>
      </div>
      <div className="mt-2">
        <VideoGenericElement
          videoData={
            selectedCandidate
              ?.AdditionalVideos?.[0] as GetSharedCandidatesRosterDataOutput['candidates'][number]['AdditionalVideos'][number]
          }
          className="w-full object-contain rounded-lg mb-2 max-h-96"
          controls
        />
      </div>
    </div>
  );
};

export default SPKVideoModal;
